import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { isMobileDevice } from "../../helpers/Utils";
import { updateMenuModel, getUserTypes } from "../../actions";
import Constants from "../../shared/constants/environmentConfig";
import NavBar from "./navbar";
import "./header.css";

const supportContact = Constants().contact;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    await this.props.getUserTypes();
  }

  renderHeaderLogo() {
    return (
      <div
        id="Header-Logo"
        role="presentation"
        style={{
          height: 60,
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => this.props.history.push(Constants().landingUrl)}
      >
        <div style={{ fontWeight: 800 }}>
          <span style={{ fontSize: 24 }}>
            <span style={{ color: "#e83242" }}>FEE </span>
            <span style={{ color: "#ffffff" }}>BOARD</span>
          </span>
        </div>
      </div>
    );
  }

  renderMobileHeader() {
    const { updateMenuModel } = this.props;
    return (
      <div
        className="Header"
        style={{
          position: "fixed",
          top: 0,
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          boxShadow: "0px 0px 3px rgba(50, 50, 50, 0.25)",
        }}
      >
        <img
          style={{ marginLeft: 20, height: 40, width: 40 }}
          src="/fee_board_favicon.svg"
          alt="FeeBoard"
          onClick={() => updateMenuModel()}
        />
      </div>
    );
  }

  render() {
    const isMobile = isMobileDevice();
    if (isMobile) {
      return this.renderMobileHeader();
    }
    return (
      <div
        style={{
          backgroundColor: "#FCFCFC",
          minHeight: "",
          maxWidth: "100%",
          overflowX: "hidden",
          width: "100%",
        }}
      >
        <NavBar globalHistory={this.props.globalHistory} isMobile={isMobile} />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  auth,
});

export default withRouter(
  connect(mapStateToProps, { updateMenuModel, getUserTypes })(Header)
);
